import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';
import invariant from 'invariant';
import { buildQueryParams, buildAffiliateBodyProperties } from '../utils';

export default function addToCart(params) {
    const {
        baseUrl,
        brandId,
        country,
        language,
        partNumber,
        quantity,
        xitem_giftMessage,
        uberToken,
        clientId,
        clientSecret,
        reservationId,
        includeShoppingCart,
        langId,
        additionalHeaders = {},
    } = params;

    invariant(baseUrl, 'baseUrl is a required param of addToCart()');
    invariant(brandId, 'brandId is a required param of addToCart()');
    invariant(country, 'country is a required param of addToCart()');
    invariant(language, 'language is a required param of addToCart()');
    invariant(partNumber, 'partNumber is a required param of addToCart()');
    invariant(quantity, 'quantity is a required param of addToCart()');
    invariant(uberToken, 'uberToken is a required param of addToCart()');
    invariant(clientId, 'clientId is a required param of addToCart()');

    const affiliateProperties = buildAffiliateBodyProperties();
    const query = buildQueryParams({ langId, includeShoppingCart: includeShoppingCart ? 'Y' : 'N' });
    const url = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/cart${query}`;
    const body = JSON.stringify({
        orderItem: [{ partNumber, quantity, xitem_giftMessage, 'xitem_attr-reservationId': reservationId }],
        ...affiliateProperties,
    });
    const headers = { ...additionalHeaders };

    return labelRequest(
        authenticatedRequest(new Request(url, { headers: new Headers(headers), method: 'POST', body }), uberToken, clientId, clientSecret),
        'addToCart',
    );
}
